import { useLocation } from 'react-router-dom';
import { Loader2, AlertTriangle } from 'lucide-react';
import BannerDettaglioBanks from '../../../components/banks/dettaglio-Banca/BannerDettaglioBanks';
import ContainerDettaglioBanks from '../../../components/banks/dettaglio-Banca/ContainerDettaglioBanks';
import { useBank } from '../../../api/hooks/useBank';
import { useBankDocuments } from '../../../api/hooks/useBankDocuments';

const Caricamento = ({ testo }: { testo: string }) => (
  <div className="flex flex-col items-center justify-center gap-3 h-screen">
    <Loader2 className="w-8 h-8 text-textPrimary/40 animate-spin" />
    <p className="text-xs text-textMuted">{testo}</p>
  </div>
);

const DettaglioBanca = () => {
  const location = useLocation();
  const id = location.state?.id as string | undefined;

  const { bank, loading: loadingBank, error: errorBank } = useBank(id);
  const { documents, loading: loadingDocs, error: errorDocs } = useBankDocuments(id);

  if (loadingBank || loadingDocs) {
    return <Caricamento testo="Caricamento della banca…" />;
  }

  if (errorBank || errorDocs) {
    return (
      <div className="px-8 lg:px-16 py-10">
        <div className="flex items-start gap-2 p-3 rounded-xl border border-red-200 bg-red-50 text-xs text-red-800">
          <AlertTriangle className="w-4 h-4 shrink-0 mt-px" />
          <span className="break-words">{errorBank ?? errorDocs}</span>
        </div>
      </div>
    );
  }

  // La pagina si raggiunge con l'id nello state della rotta: senza, gli hook non
  // hanno nulla da caricare e resterebbero in attesa per sempre.
  if (!bank || !documents) {
    return <Caricamento testo="Caricamento della banca…" />;
  }

  return (
    <div className="flex flex-col bg-background min-h-screen">
      <BannerDettaglioBanks name={bank.name} />
      <div className="px-8 lg:px-16 py-8">
        <ContainerDettaglioBanks bank={bank} documents={documents} />
      </div>
    </div>
  );
};

export default DettaglioBanca;
